import { LegalPageLayout } from "@/components/legal/LegalPageLayout";
import { LegalSection } from "@/components/legal/LegalSection";

const tableOfContents = [
  { id: "gioi-thieu", title: "Giới thiệu", level: 1 },
  { id: "thong-tin-thu-thap", title: "Thông tin chúng tôi thu thập", level: 1 },
  {
    id: "cach-su-dung-thong-tin",
    title: "Cách chúng tôi sử dụng thông tin",
    level: 1,
  },
  {
    id: "dich-vu-khan-cap-vi-tri",
    title: "Dịch vụ Khẩn cấp và Dữ liệu Vị trí",
    level: 1,
  },
  { id: "chia-se-thong-tin", title: "Chia sẻ và tiết lộ thông tin", level: 1 },
  { id: "bao-mat-du-lieu", title: "Bảo mật dữ liệu", level: 1 },
  { id: "quyen-cua-ban", title: "Quyền và lựa chọn của bạn", level: 1 },
  { id: "cookies", title: "Cookies và công nghệ theo dõi", level: 1 },
  { id: "chuyen-giao-quoc-te", title: "Chuyển giao dữ liệu quốc tế", level: 1 },
  { id: "quyen-rieng-tu-tre-em", title: "Quyền riêng tư của trẻ em", level: 1 },
  { id: "thay-doi", title: "Thay đổi chính sách này", level: 1 },
  { id: "lien-he", title: "Liên hệ với chúng tôi", level: 1 },
];

export default function PrivacyPolicyVietnamese() {
  return (
    <LegalPageLayout
      title="Chính sách Bảo mật"
      lastUpdated="6 tháng 1, 2025"
      language="vi"
      alternateUrl="/pages/privacy"
      tableOfContents={tableOfContents}
    >
      <LegalSection id="gioi-thieu" title="Giới thiệu">
        <p>
          Chào mừng bạn đến với Locuno, một nền tảng mạng xã hội kết nối mọi
          người trong các cộng đồng địa phương. Tại Locuno, chúng tôi cam kết
          bảo vệ quyền riêng tư của bạn và đảm bảo tính minh bạch về cách chúng
          tôi thu thập, sử dụng và bảo vệ thông tin cá nhân của bạn.
        </p>
        <p>
          Chính sách Bảo mật này giải thích cách Cloudjet Solutions Pte. Ltd.
          ("Locuno," "chúng tôi," "của chúng tôi") thu thập, sử dụng, chia sẻ và
          bảo vệ thông tin về bạn khi bạn sử dụng các dịch vụ mạng xã hội của
          chúng tôi, bao gồm trang web, ứng dụng di động và bất kỳ dịch vụ nào
          khác mà chúng tôi cung cấp (gọi chung là "Dịch vụ").
        </p>
        <p>
          Bằng việc sử dụng Dịch vụ của chúng tôi, bạn đồng ý với việc thu thập
          và sử dụng thông tin theo chính sách này. Nếu bạn không đồng ý với các
          chính sách và thông lệ của chúng tôi, vui lòng không sử dụng Dịch vụ
          của chúng tôi.
        </p>
      </LegalSection>

      <LegalSection
        id="thong-tin-thu-thap"
        title="Thông tin chúng tôi thu thập"
      >
        <h3>Thông tin bạn cung cấp cho chúng tôi</h3>
        <p>
          Chúng tôi thu thập thông tin bạn cung cấp trực tiếp cho chúng tôi, bao
          gồm:
        </p>
        <ul>
          <li>
            <strong>Thông tin tài khoản:</strong> Tên người dùng, địa chỉ email,
            mật khẩu, ảnh đại diện và tên hiển thị
          </li>
          <li>
            <strong>Thông tin hồ sơ:</strong> Thông tin tiểu sử, sở thích, vị
            trí và các thông tin hồ sơ khác bạn chọn chia sẻ
          </li>
          <li>
            <strong>Nội dung:</strong> Bài đăng, bình luận, tin nhắn, ảnh, video
            và nội dung khác bạn tạo hoặc chia sẻ
          </li>
          <li>
            <strong>Thông tin liên lạc:</strong> Tin nhắn bạn gửi cho chúng tôi
            hoặc người dùng khác qua nền tảng của chúng tôi
          </li>
          <li>
            <strong>Dữ liệu vị trí:</strong> Vị trí của bạn khi bạn chọn chia sẻ
            hoặc bật dịch vụ vị trí
          </li>
        </ul>

        <h3>Thông tin chúng tôi thu thập tự động</h3>
        <p>
          Khi bạn sử dụng Dịch vụ của chúng tôi, chúng tôi tự động thu thập một
          số thông tin nhất định:
        </p>
        <ul>
          <li>
            <strong>Thông tin sử dụng:</strong> Cách bạn tương tác với Dịch vụ
            của chúng tôi, bao gồm các trang đã truy cập, tính năng đã sử dụng
            và thời gian sử dụng
          </li>
          <li>
            <strong>Thông tin thiết bị:</strong> Loại thiết bị, hệ điều hành,
            loại trình duyệt, địa chỉ IP và định danh thiết bị duy nhất
          </li>
          <li>
            <strong>Dữ liệu nhật ký:</strong> Nhật ký máy chủ bao gồm địa chỉ
            IP, thời gian truy cập, trang đã xem và thống kê sử dụng khác
          </li>
          <li>
            <strong>Cookies và công nghệ tương tự:</strong> Chúng tôi sử dụng
            cookies, web beacon và công nghệ theo dõi tương tự
          </li>
        </ul>

        <h3>Thông tin từ bên thứ ba</h3>
        <p>Chúng tôi có thể nhận thông tin về bạn từ bên thứ ba, bao gồm:</p>
        <ul>
          <li>
            Người dùng khác nhắc đến bạn hoặc bao gồm bạn trong nội dung của họ
          </li>
          <li>
            Dịch vụ bên thứ ba bạn kết nối với tài khoản của mình (như nền tảng
            mạng xã hội)
          </li>
          <li>Nhà cung cấp phân tích và đối tác quảng cáo</li>
          <li>Cơ sở dữ liệu công cộng và nhà cung cấp dữ liệu</li>
        </ul>
      </LegalSection>

      <LegalSection
        id="cach-su-dung-thong-tin"
        title="Cách chúng tôi sử dụng thông tin của bạn"
      >
        <p>Chúng tôi sử dụng thông tin thu thập được để:</p>
        <ul>
          <li>
            <strong>Cung cấp và cải thiện Dịch vụ:</strong> Vận hành, duy trì và
            cải thiện nền tảng và tính năng của chúng tôi
          </li>
          <li>
            <strong>Cá nhân hóa:</strong> Tùy chỉnh trải nghiệm của bạn và hiển
            thị nội dung và kết nối liên quan
          </li>
          <li>
            <strong>Liên lạc:</strong> Gửi cho bạn cập nhật, thông báo và phản
            hồi các thắc mắc của bạn
          </li>
          <li>
            <strong>An toàn và bảo mật:</strong> Bảo vệ chống gian lận, lạm dụng
            và các hoạt động có hại khác
          </li>
          <li>
            <strong>Phân tích:</strong> Hiểu cách Dịch vụ của chúng tôi được sử
            dụng và cải thiện trải nghiệm người dùng
          </li>
          <li>
            <strong>Tuân thủ pháp lý:</strong> Tuân thủ các nghĩa vụ pháp lý và
            thực thi điều khoản dịch vụ của chúng tôi
          </li>
          <li>
            <strong>Tiếp thị:</strong> Với sự đồng ý của bạn, gửi cho bạn nội
            dung khuyến mại về các tính năng và dịch vụ mới
          </li>
        </ul>

        <h3>Cơ sở pháp lý để xử lý (GDPR)</h3>
        <p>
          Đối với người dùng trong Liên minh Châu Âu, chúng tôi xử lý dữ liệu cá
          nhân của bạn dựa trên:
        </p>
        <ul>
          <li>
            <strong>Sự đồng ý:</strong> Khi bạn cung cấp sự đồng ý rõ ràng cho
            các hoạt động xử lý cụ thể
          </li>
          <li>
            <strong>Hợp đồng:</strong> Để thực hiện các nghĩa vụ hợp đồng của
            chúng tôi trong việc cung cấp Dịch vụ
          </li>
          <li>
            <strong>Lợi ích chính đáng:</strong> Cho các lợi ích kinh doanh
            chính đáng của chúng tôi, chẳng hạn như cải thiện Dịch vụ của chúng
            tôi
          </li>
          <li>
            <strong>Nghĩa vụ pháp lý:</strong> Để tuân thủ các luật và quy định
            áp dụng
          </li>
        </ul>
      </LegalSection>

      <LegalSection
        id="dich-vu-khan-cap-vi-tri"
        title="Dịch vụ Khẩn cấp và Dữ liệu Vị trí"
      >
        <h3>Dịch vụ Định vị Khẩn cấp</h3>
        <p>
          Locuno cung cấp các tính năng dựa trên vị trí có thể được sử dụng
          trong các tình huống khẩn cấp. Khi bạn bật dịch vụ định vị và sử dụng
          các tính năng liên quan đến khẩn cấp, chúng tôi thu thập và xử lý dữ
          liệu vị trí như sau:
        </p>

        <h3>Thu thập Dữ liệu Vị trí cho Dịch vụ Khẩn cấp</h3>
        <p>
          <strong>Các loại Dữ liệu Vị trí:</strong>
        </p>
        <ul>
          <li>
            <strong>Vị trí Thời gian thực:</strong> Tọa độ GPS hiện tại của bạn
            khi bạn kích hoạt các tính năng khẩn cấp
          </li>
          <li>
            <strong>Lịch sử Vị trí:</strong> Dữ liệu vị trí gần đây để giúp dịch
            vụ khẩn cấp hiểu các mẫu di chuyển của bạn
          </li>
          <li>
            <strong>Vị trí Thiết bị:</strong> Thông tin vị trí từ GPS, Wi-Fi và
            mạng di động của thiết bị
          </li>
          <li>
            <strong>Bối cảnh Khẩn cấp:</strong> Bối cảnh vị trí bổ sung như các
            địa danh hoặc địa chỉ gần đó
          </li>
        </ul>

        <h3>Tích hợp Nhà cung cấp Dịch vụ Khẩn cấp</h3>
        <p>
          Khi bạn sử dụng các tính năng khẩn cấp, dữ liệu vị trí của bạn có thể
          được chia sẻ với:
        </p>
        <ul>
          <li>
            <strong>Nhà cung cấp Dịch vụ Khẩn cấp được Chứng nhận:</strong> Các
            nhà cung cấp dịch vụ khẩn cấp bên thứ ba được đào tạo để nhận và xử
            lý các yêu cầu khẩn cấp dựa trên vị trí
          </li>
          <li>
            <strong>Liên hệ Khẩn cấp:</strong> Các liên hệ khẩn cấp được chỉ
            định mà bạn đã chỉ định trong cài đặt tài khoản
          </li>
          <li>
            <strong>Mạng An toàn Cộng đồng:</strong> Các thành viên cộng đồng
            gần đó có thể hỗ trợ trong các tình huống khẩn cấp
          </li>
          <li>
            <strong>Cơ quan An toàn Công cộng:</strong> Các dịch vụ khẩn cấp địa
            phương (911, 112, v.v.) khi bạn yêu cầu hỗ trợ khẩn cấp một cách rõ
            ràng
          </li>
        </ul>

        <h3>Khả năng của Nhà cung cấp Dịch vụ Khẩn cấp</h3>
        <p>
          Các nhà cung cấp dịch vụ khẩn cấp của chúng tôi được trang bị các hệ
          thống có thể:
        </p>
        <ul>
          <li>
            <strong>Nhận Dữ liệu Vị trí:</strong> Chấp nhận và xử lý thông tin
            vị trí từ các yêu cầu khẩn cấp
          </li>
          <li>
            <strong>Xác định Vị trí:</strong> Chuyển đổi tọa độ GPS thành địa
            chỉ và địa danh có thể nhận biết
          </li>
          <li>
            <strong>Xử lý Yêu cầu Khẩn cấp:</strong> Xử lý các thông báo khẩn
            cấp dựa trên vị trí theo tiêu chuẩn ngành
          </li>
          <li>
            <strong>Phối hợp Phản ứng:</strong> Làm việc với các dịch vụ khẩn
            cấp địa phương để tạo điều kiện phản ứng thích hợp
          </li>
        </ul>

        <h3>Xử lý Dữ liệu cho Dịch vụ Khẩn cấp</h3>
        <p>Chúng tôi xử lý dữ liệu vị trí cho dịch vụ khẩn cấp dựa trên:</p>
        <ul>
          <li>
            <strong>Sự đồng ý Rõ ràng:</strong> Khi bạn kích hoạt các tính năng
            khẩn cấp và đồng ý chia sẻ vị trí
          </li>
          <li>
            <strong>Lợi ích Chính đáng:</strong> Để bảo vệ an toàn của bạn và an
            toàn của người khác trong các tình huống khẩn cấp
          </li>
          <li>
            <strong>Lợi ích Sinh tử:</strong> Để bảo vệ tính mạng hoặc an toàn
            thể chất của bạn trong các tình huống khẩn cấp
          </li>
          <li>
            <strong>Nghĩa vụ Pháp lý:</strong> Khi được yêu cầu bởi luật pháp
            hoặc quy định dịch vụ khẩn cấp
          </li>
        </ul>

        <h3>Lưu trữ Dữ liệu Vị trí cho Dịch vụ Khẩn cấp</h3>
        <p>Dữ liệu vị trí được sử dụng cho dịch vụ khẩn cấp được lưu trữ:</p>
        <ul>
          <li>
            <strong>Tình huống Khẩn cấp:</strong> Trong thời gian khẩn cấp và
            hậu quả trực tiếp
          </li>
          <li>
            <strong>Cải thiện Dịch vụ:</strong> Dữ liệu ẩn danh có thể được lưu
            trữ để cải thiện khả năng phản ứng khẩn cấp
          </li>
          <li>
            <strong>Yêu cầu Pháp lý:</strong> Theo yêu cầu của luật pháp hoặc
            quy định dịch vụ khẩn cấp
          </li>
          <li>
            <strong>Yêu cầu Người dùng:</strong> Cho đến khi bạn yêu cầu xóa,
            tuân theo các yêu cầu lưu trữ pháp lý
          </li>
        </ul>

        <h3>Giới hạn Dịch vụ Khẩn cấp</h3>
        <p>
          <strong>Giới hạn Quan trọng:</strong>
        </p>
        <ul>
          <li>
            <strong>Không Đảm bảo:</strong> Chúng tôi không thể đảm bảo rằng các
            dịch vụ khẩn cấp sẽ nhận hoặc phản ứng với dữ liệu vị trí
          </li>
          <li>
            <strong>Phụ thuộc Kỹ thuật:</strong> Dịch vụ định vị phụ thuộc vào
            khả năng thiết bị, kết nối mạng và tín hiệu GPS
          </li>
          <li>
            <strong>Trách nhiệm Người dùng:</strong> Bạn vẫn chịu trách nhiệm
            liên hệ với các dịch vụ khẩn cấp chính thức (911, 112, v.v.) cho các
            tình huống đe dọa tính mạng
          </li>
          <li>
            <strong>Tính khả dụng Dịch vụ:</strong> Các tính năng khẩn cấp có
            thể không có sẵn ở tất cả các vị trí hoặc hoàn cảnh
          </li>
        </ul>

        <h3>Quyền của Bạn về Dữ liệu Vị trí Khẩn cấp</h3>
        <p>Bạn có quyền:</p>
        <ul>
          <li>
            <strong>Kiểm soát Chia sẻ Vị trí:</strong> Bật hoặc tắt dịch vụ định
            vị cho các tính năng khẩn cấp
          </li>
          <li>
            <strong>Chỉ định Liên hệ Khẩn cấp:</strong> Chọn ai sẽ nhận được vị
            trí của bạn trong các tình huống khẩn cấp
          </li>
          <li>
            <strong>Truy cập Dữ liệu Vị trí:</strong> Yêu cầu bản sao dữ liệu vị
            trí được sử dụng cho dịch vụ khẩn cấp
          </li>
          <li>
            <strong>Xóa Dữ liệu Vị trí:</strong> Yêu cầu xóa dữ liệu vị trí,
            tuân theo các yêu cầu pháp lý
          </li>
          <li>
            <strong>Rút lại Sự đồng ý:</strong> Thu hồi sự đồng ý cho việc chia
            sẻ vị trí khẩn cấp bất cứ lúc nào
          </li>
        </ul>
      </LegalSection>

      <LegalSection id="chia-se-thong-tin" title="Chia sẻ và tiết lộ thông tin">
        <p>
          Chúng tôi có thể chia sẻ thông tin của bạn trong các trường hợp sau:
        </p>

        <h3>Thông tin công khai</h3>
        <p>
          Thông tin bạn chọn công khai (chẳng hạn như hồ sơ, bài đăng và bình
          luận của bạn) có thể hiển thị với người dùng khác và công chúng. Vui
          lòng cân nhắc kỹ về những gì bạn chọn chia sẻ công khai.
        </p>

        <h3>Với người dùng khác</h3>
        <p>
          Chúng tôi chia sẻ thông tin với người dùng khác như một phần của chức
          năng mạng xã hội, bao gồm thông tin hồ sơ, bài đăng và tương tác của
          bạn.
        </p>

        <h3>Nhà cung cấp dịch vụ</h3>
        <p>
          Chúng tôi có thể chia sẻ thông tin với các nhà cung cấp dịch vụ bên
          thứ ba thực hiện dịch vụ thay mặt chúng tôi, chẳng hạn như lưu trữ,
          phân tích, hỗ trợ khách hàng và xử lý thanh toán.
        </p>

        <h3>Chuyển giao kinh doanh</h3>
        <p>
          Nếu chúng tôi tham gia vào việc sáp nhập, mua lại hoặc bán tài sản,
          thông tin của bạn có thể được chuyển giao như một phần của giao dịch
          đó.
        </p>

        <h3>Yêu cầu pháp lý</h3>
        <p>
          Chúng tôi có thể tiết lộ thông tin nếu được yêu cầu theo pháp luật
          hoặc nếu chúng tôi tin một cách thiện chí rằng việc tiết lộ như vậy là
          cần thiết để:
        </p>
        <ul>
          <li>Tuân thủ quy trình pháp lý hoặc yêu cầu của chính phủ</li>
          <li>
            Thực thi điều khoản dịch vụ hoặc các thỏa thuận khác của chúng tôi
          </li>
          <li>
            Bảo vệ quyền, tài sản hoặc sự an toàn của Locuno, người dùng của
            chúng tôi hoặc những người khác
          </li>
          <li>Ngăn chặn gian lận hoặc các hoạt động bất hợp pháp khác</li>
        </ul>
      </LegalSection>

      <LegalSection id="bao-mat-du-lieu" title="Bảo mật dữ liệu">
        <p>
          Chúng tôi thực hiện các biện pháp kỹ thuật và tổ chức thích hợp để bảo
          vệ thông tin cá nhân của bạn chống lại truy cập trái phép, thay đổi,
          tiết lộ hoặc phá hủy. Các biện pháp này bao gồm:
        </p>
        <ul>
          <li>Mã hóa dữ liệu khi truyền tải và khi lưu trữ</li>
          <li>Đánh giá và cập nhật bảo mật thường xuyên</li>
          <li>Kiểm soát truy cập và quy trình xác thực</li>
          <li>Đào tạo nhân viên về bảo vệ dữ liệu</li>
          <li>Quy trình ứng phó sự cố</li>
        </ul>
        <p>
          Tuy nhiên, không có phương thức truyền tải qua internet hoặc lưu trữ
          điện tử nào an toàn 100%. Trong khi chúng tôi nỗ lực bảo vệ thông tin
          của bạn, chúng tôi không thể đảm bảo tính bảo mật tuyệt đối.
        </p>
      </LegalSection>

      <LegalSection id="quyen-cua-ban" title="Quyền và lựa chọn của bạn">
        <h3>Cài đặt tài khoản</h3>
        <p>
          Bạn có thể cập nhật thông tin tài khoản và cài đặt quyền riêng tư
          thông qua bảng điều khiển tài khoản của mình.
        </p>

        <h3>Truy cập và di chuyển dữ liệu</h3>
        <p>
          Bạn có quyền truy cập và tải xuống dữ liệu cá nhân của mình. Bạn có
          thể yêu cầu bản sao dữ liệu của mình thông qua cài đặt tài khoản.
        </p>

        <h3>Sửa đổi và xóa dữ liệu</h3>
        <p>
          Bạn có thể sửa đổi thông tin không chính xác hoặc yêu cầu xóa tài
          khoản và dữ liệu cá nhân của mình.
        </p>

        <h3>Tùy chọn liên lạc</h3>
        <p>
          Bạn có thể từ chối nhận thông tin khuyến mại bằng cách làm theo hướng
          dẫn hủy đăng ký hoặc cập nhật tùy chọn của mình.
        </p>

        <h3>Quyền theo GDPR (Người dùng EU)</h3>
        <p>Nếu bạn ở Liên minh Châu Âu, bạn có các quyền bổ sung bao gồm:</p>
        <ul>
          <li>Quyền sửa đổi dữ liệu không chính xác</li>
          <li>Quyền xóa ("quyền được quên")</li>
          <li>Quyền hạn chế xử lý</li>
          <li>Quyền di chuyển dữ liệu</li>
          <li>Quyền phản đối việc xử lý</li>
          <li>Quyền rút lại sự đồng ý</li>
        </ul>

        <h3>Quyền riêng tư California (CCPA)</h3>
        <p>Cư dân California có quyền:</p>
        <ul>
          <li>Biết thông tin cá nhân nào được thu thập</li>
          <li>Xóa thông tin cá nhân</li>
          <li>Từ chối việc bán thông tin cá nhân</li>
          <li>Không bị phân biệt đối xử khi thực hiện quyền riêng tư</li>
        </ul>
      </LegalSection>

      <LegalSection id="cookies" title="Cookies và công nghệ theo dõi">
        <p>
          Chúng tôi sử dụng cookies và công nghệ tương tự để nâng cao trải
          nghiệm của bạn, phân tích việc sử dụng và cung cấp nội dung được cá
          nhân hóa. Để biết thông tin chi tiết về việc sử dụng cookies của chúng
          tôi, vui lòng xem
          <a href="/pages/vi/cookies" className="text-blue-600 hover:underline">
            Chính sách Cookie
          </a>{" "}
          của chúng tôi.
        </p>
        <p>
          Bạn có thể kiểm soát cookies thông qua cài đặt trình duyệt của mình,
          nhưng việc tắt cookies có thể ảnh hưởng đến chức năng của Dịch vụ của
          chúng tôi.
        </p>
      </LegalSection>

      <LegalSection
        id="chuyen-giao-quoc-te"
        title="Chuyển giao dữ liệu quốc tế"
      >
        <p>
          Thông tin của bạn có thể được chuyển đến và xử lý ở các quốc gia khác
          ngoài quốc gia cư trú của bạn. Các quốc gia này có thể có luật bảo vệ
          dữ liệu khác với quốc gia của bạn.
        </p>
        <p>
          Khi chúng tôi chuyển dữ liệu cá nhân từ Liên minh Châu Âu đến các quốc
          gia khác, chúng tôi đảm bảo có các biện pháp bảo vệ thích hợp, chẳng
          hạn như Điều khoản Hợp đồng Tiêu chuẩn hoặc quyết định đầy đủ.
        </p>
      </LegalSection>

      <LegalSection
        id="quyen-rieng-tu-tre-em"
        title="Quyền riêng tư của trẻ em"
      >
        <p>
          Dịch vụ của chúng tôi không dành cho trẻ em dưới 13 tuổi. Chúng tôi
          không cố ý thu thập thông tin cá nhân từ trẻ em dưới 13 tuổi. Nếu
          chúng tôi biết rằng mình đã thu thập thông tin cá nhân từ trẻ em dưới
          13 tuổi, chúng tôi sẽ thực hiện các bước để xóa thông tin đó.
        </p>
        <p>
          Nếu bạn là cha mẹ hoặc người giám hộ và tin rằng con bạn đã cung cấp
          thông tin cá nhân cho chúng tôi, vui lòng liên hệ với chúng tôi để
          chúng tôi có thể thực hiện hành động thích hợp.
        </p>
      </LegalSection>

      <LegalSection id="thay-doi" title="Thay đổi chính sách này">
        <p>
          Chúng tôi có thể cập nhật Chính sách Bảo mật này theo thời gian. Khi
          chúng tôi thực hiện các thay đổi, chúng tôi sẽ thông báo cho bạn bằng
          cách cập nhật ngày "Cập nhật lần cuối" và, đối với các thay đổi quan
          trọng, chúng tôi có thể cung cấp thông báo bổ sung thông qua Dịch vụ
          của chúng tôi hoặc email.
        </p>
        <p>
          Việc bạn tiếp tục sử dụng Dịch vụ của chúng tôi sau bất kỳ thay đổi
          nào đối với Chính sách Bảo mật này có nghĩa là bạn chấp nhận chính
          sách đã cập nhật.
        </p>
      </LegalSection>

      <LegalSection id="lien-he" title="Liên hệ với chúng tôi">
        <p>
          Nếu bạn có bất kỳ câu hỏi nào về Chính sách Bảo mật này hoặc thông lệ
          bảo mật của chúng tôi, vui lòng liên hệ với chúng tôi:
        </p>
        <div className="bg-gray-50 p-4 rounded-lg mt-4">
          <p>
            <strong>Tên công ty:</strong> CÔNG TY TNHH CLOUDJET SOLUTIONS
          </p>
          <p>
            <strong>Địa chỉ:</strong> Lầu 2, Tòa nhà F Central, 16A Lê Hồng
            Phong, Phường 12, Quận 10, TP. Hồ Chí Minh, Việt Nam
          </p>
          <p>
            <strong>Mã số thuế:</strong> 0312033924
          </p>
          <p>
            <strong>Điện thoại:</strong> 028 628 00110
          </p>
          <p>
            <strong>Email:</strong> contact@locuno.com
          </p>
          <p>
            <strong>Quyền riêng tư:</strong> privacy@locuno.com
          </p>
          <p>
            <strong>Cán bộ Bảo vệ Dữ liệu:</strong> dpo@locuno.com
          </p>
        </div>
      </LegalSection>
    </LegalPageLayout>
  );
}
